var constants = require('../constants');

var surveyMetaActions = (function() {

    var _getRecordAction = function(type, action, label){
        return {
            type: type,
            meta: {
                analytics: {
                    eventType: type,
                    actionValue: action,
                    labelValue: label
                }
            }
        };
    }

    var _recordSurveyButtonClicked = function(label) {
        return _getRecordAction(constants.SURVEY_BUTTON_CLICKED, 'Survey Button Clicked', label);
    }

    var _recordSurveyStarted = function(label){
        return _getRecordAction(constants.SURVEY_STARTED, 'Survey Started', label);
    }

    var _recordSurveyCompleted = function(label){
        return _getRecordAction(constants.SURVEY_COMPLETED, 'Survey Completed', label);
    }

    return {
        recordSurveyButtonClicked: _recordSurveyButtonClicked,
        recordSurveyStarted: _recordSurveyStarted,
        recordSurveyCompleted: _recordSurveyCompleted
    }
})();

module.exports = surveyMetaActions;



// WEBPACK FOOTER //
// ./src/common/modules/meta/actions/survey.js